import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { useIdleTimer } from 'react-idle-timer';

const IDLE_TIMEOUT = getTimeInMs(1, 'hour');

export const useUserIdle = (timeout = IDLE_TIMEOUT) => {
  const { isIdle } = useIdleTimer({
    timeout,
    throttle: 500,
    crossTab: true,
  });

  return isIdle();
};
